import React from 'react'
import { Dropdown } from 'primereact/dropdown';

import InputWrapper from './InputWrapper';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import dropDownIcn from './Images/icn-dropdown.png';

// Utilities

import { setNestedFieldName, setNestedFieldError } from '../../../utilities/helper-functions';

import './Styles.scss';

export default function DropDownInput(props) {
    const {
        formik,
        fieldName,
        isRequired,
        options,
        placeholder,
        additionalFunctions,
        disabled,
        loading,
        showClear,
    } = props;

    const value = fieldName.includes('.') ? setNestedFieldName(fieldName, formik.values) : formik.values[fieldName];
    const error = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.errors) : formik.errors[fieldName];
    const touched = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.touched) : formik.touched[fieldName];

    return (
        <InputWrapper {...props}>
            <Dropdown
                name={fieldName}
                className={`input-field ${error && touched ? 'p-invalid' : ''}`}
                value={fieldName.includes('.') ? setNestedFieldName(fieldName, formik.values) : formik.values[fieldName]}
                options={options}
                onChange={(e) => { 
                    formik.setFieldValue(fieldName, e.target.value); 
                    if (additionalFunctions) { 
                        additionalFunctions() 
                    }
                }}
                onBlur={formik.handleBlur(fieldName)}
                dropdownIcon={''}
                required={isRequired}
                placeholder={placeholder ? placeholder : 'Seleccione'}
                disabled={disabled}
                showClear={showClear && value !== '' ? showClear : false}
                filter
            />

            {loading ? (
                <FontAwesomeIcon className='dropdown-icon drowpdown-loading-icon' icon={faCircleNotch} spin />
            ) : (
                <img src={dropDownIcn} className='dropdown-icon' alt={fieldName} />
            )}

        </InputWrapper>
    )
}

